<main class="section">
    <div class="section-title">
        <slot name="section-title"></slot>
    </div>
    <div class="section-items">
        <slot name="section-items"></slot>
    </div>
</main>

<style>
    .section {
        margin-top: 2px;
        border-radius: 5px;
        min-width: 400px;
    }
    .section-title {
        border: 0;
        padding: 0 6px 26px 0;
        text-align: left;
        font-weight: 600;
        font-size: 16px;
        opacity: 0.8;
    }
    .section-items {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        row-gap: 4px;
        font-weight: 200;
        font-size: 15px;
    }
</style>